import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";
import Banner from "../components/img/Banner/Purpule.png";

import Navbar from "../components/Navbar";
import Footer from "../components/common-components/Footer";

const Terms = () => {
  const testimonialsRef = useRef(null);

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const terms = [
    {
      number: "1.",
      title: "Attendance and Punctuality:-",
      description:
        "All students are expected to attend classes regularly and be on time. Tardiness disrupts the learning environment and may result in consequences. Notify the coaching centre in advance if you will be absent in case of an emergency.  ",
    },
    {
      number: "2.",
      title: "Code Of Conduct:-",
      description:
        "Students and Parents are expected to respect the teachers, students, and coaching centre staff. Disruptive or disrespectful behaviour will not be tolerated at any cost. Avoid any form of discrimination, harassment, or bullying. Any serious violation may lead to direct expulsion from the class and fees will not be refunded nor adjusted.",
    },
    {
      number: "3.",
      title: "Dress Code:-",
      description:
        "Maintain a neat and appropriate appearance while attending classes.",
    },
    {
      number: "4.",
      title: "Mobile Phones and Electronic Devices:-",
      description:
        "Mobile phones and electronic devices should be turned off or put on silent mode during class. Use of these devices should be limited to designated break times.",
    },
    {
      number: "5.",
      title: "Classroom Etiquette:-",
      description:
        "Keep your workspace tidy and organized. No seat to be reserved for any student or friends. Strict action will be taken if found doing so. Raise your hand to ask questions or contribute to discussions. Avoid side conversations during lectures.",
    },
    {
      number: "6.",
      title: "Academic Integrity:-",
      description:
        "Plagiarism, cheating, or any form of academic dishonesty is strictly prohibited. Uphold the highest standards of academic integrity.",
    },
    {
      number: "7.",
      title: "Safety:-",
      description:
        " Follow all safety guidelines and instructions provided by the coaching centre. In case of emergencies, follow evacuation procedures and cooperate with staff.",
    },
    {
      number: "8.",
      title: "Materials and Equipment:-",
      description:
        "Handle coaching centre materials and equipment with care. Report any damage or issues to the coaching centre staff immediately. Any damage caused should be compensated for the part damaged or in full, as applicable in the case.",
    },
    {
      number: "9.",
      title: "Payment and Fees:-",
      description:
        "Ensure that all fees and payments are made on time as per the agreed-upon schedule. Non-payment may result in suspension from classes. Fees to be paid for the full month and not any specific number days or classes. If Hrishi’s Holistic Hub declares an off on a scheduled day, the same will be communicated and compensated, if the child remains absent on the day of the scheduled class, he/she will be marked absent. If the child remains absent, no extra classes would be given. In case of additional classes, apart from the allotted classes, if anyone wishes to take an extra class/es or one-on-one sessions then it will be a paid class and charged on hourly basis. Late fees may be charged in case of regular delay.",
    },
    {
      number: "10.",
      title: "Holidays:-",
      description:
        "The institute will remain closed on all National Holidays and majorly celebrated festivals. No compensatory classes will be allotted for the same. The institute has all the rights to call the students on these days and get the syllabus covered/conduct exams if required.",
    },
    {
      number: "11.",
      title: "Amendments to Rules:-",
      description:
        "The institute reserves the right to amend or modify these rules and regulations as needed. Any changes will be communicated in advance.",
    },
    {
      number: "12.",
      title: "Mode of Classes:-",
      description:
        "The classes are majorly conducted offline; however, the institute may conduct the classes online as and when required by communicating prior. Yes, a student can attend the class online if he/she is travelling somewhere, or is unwell on a scheduled offline class. The institute takes no responsibility of any power cuts or disturbances in the network during the lecture, however it will strive to deliver the best.",
    },
    {
      number: "13.",
      title: "Syllabus:-",
      description:
        "The class will follow its own schedule of chapters, however, the syllabus of your child will be taken care off, by teaching the chapter separately or by conducting additional classes only if required. No school homework/classwork or projects would be done at the centre. The subject teacher may guide the child if he/she has any doubts in it. ",
    },
  ];

  return (
    <Box className="root-container" sx={{ overflowX: "hidden" }}>
      <Navbar scrollToTestimonials={scrollToTestimonials} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "308px", md: "1319px" }, // Mobile width: 358px, Desktop width: 1319px
            height: { xs: "315px", md: "339px" }, // Mobile height: 321px, Desktop height: 339px
            mt: "14vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            overflow: "hidden", // Ensures cropping effect
          }}
        >
          <img
            src={Banner}
            alt="Courses Banner"
            style={{
              width: "100%", // Scales the image responsively
              height: "100%", // Ensures it fills the Box
              objectFit: "cover", // Crops the image to fit while maintaining aspect ratio
              objectPosition: "center", // Keeps the focus on the center
              borderRadius: "8px",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              padding: "5px 10px",
              borderRadius: "5px",
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "28px",
                color: "#FFFFFF",
                fontFamily: "'Kumbh Sans', sans-serif",
              }}
            >
              Terms & Condition
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",
                  color: "#FFFFFF",
                  fontFamily: "'Kumbh Sans', sans-serif",
                  pr: "5px",
                }}
              >
                Home
              </Typography>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "20px",
                  color: "#FFCC25",
                  fontFamily: "'Kumbh Sans', sans-serif",
                }}
              >
                {" "}
                / Terms & Condition
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            marginLeft: { xs: "6px", sm: "10px", md: "20px" }, // Dynamic margins for different screens
            marginRight: { xs: "6px", sm: "10px", md: "0px" },
            marginTop: 3,
            alignItems: "center",
            maxWidth: { xs: "100%", sm: "95%", md: "1300px" }, // Adjust width for mobile, tablet, and desktop
          }}
        >
          {" "}
          {terms.map((terms, index) => (
            <Typography
              key={index}
              variant="body1"
              sx={{
                textAlign: "justify",
                marginBottom: 2,
                fontSize: { xs: "14px", sm: "14px", md: "16px" },
              }}
            >
              <strong
                style={{
                  fontFamily: "Kumbh Sans",
                  fontSize: window.innerWidth < 600 ? "14px" : "18px",
                }}
              >
                {terms.number} {terms.title}
              </strong>{" "}
              <span
                style={{
                  fontFamily: "Quicksand",
                  fontSize: window.innerWidth < 600 ? "14px" : "16px",
                }}
              >
                {terms.description}
              </span>
            </Typography>
          ))}
        <Typography
        variant="body1"
        sx={{
          textAlign: "justify",
          marginBottom: 2,
          fontSize: { xs: "14px", sm: "14px", md: "16px" },
        }}>
        *Kindly note that we want to make it clear that these rules and regulations are not set in stone. We understand that the educational landscape can evolve, and the needs of our students may change over time. Therefore, we reserve the right to add, modify, or adjust these rules and regulations as and when required to enhance the quality of education and ensure the welfare of our students.
        </Typography>
        </Box>
      </Box>

      <Box className="footer-class" sx={{ width: "100%" }}>
        {" "}
        <Footer />
      </Box>
    </Box>
  );
};

export default Terms;
